import { logger, globalMetadata as globalLogMetadata } from '../logger';
import { LogLevel } from '../types';
export function logReporter(info, config) {
    const reporter = {
        ...config,
        trackEvent(event) {
            // config.trackEventLevel and config.level overrides event.level here, as it is an override, while config.trackEventDefaultLevel is a fallback.
            const level = event.level ?? config.trackEventDefaultLevel ?? LogLevel.Info;
            logger.log(level, event.message, {
                ...(event.metadata ?? {}),
                ...(event.metrics ?? {}),
                ...(event.tags ?? {}),
            });
        },
        addBreadcrumb(breadcrumb) {
            const level = config.addBreadcrumbLevel ?? LogLevel.Info;
            logger.log(level, breadcrumb.message, {
                ...(breadcrumb.metadata ?? {}),
                category: breadcrumb.category,
            });
        },
        addMetadata(metadata) {
            Object.assign(globalLogMetadata, metadata);
        },
        setUser(user) {
            Object.assign(globalLogMetadata, { user });
        },
        setRouteName(routeName) {
            Object.assign(globalLogMetadata, { routeName });
            const level = config.setRouteNameLevel ?? LogLevel.Debug;
            logger.log(level, `Route changed to ${routeName}`);
        },
        setPageName(pageName) {
            Object.assign(globalLogMetadata, { pageName });
            const level = config.setPageNameLevel ?? LogLevel.Debug;
            logger.log(level, `Page changed to ${pageName}`);
        },
        reportError(error, metadata) {
            logger.error(typeof error === 'string' ? error : error.message, { ...metadata, error });
        },
        recordSession() {
            const level = config.recordSessionLevel ?? LogLevel.Debug;
            logger.log(level, 'Recording Session');
        },
        recordSessionStop() {
            const level = config.recordSessionStopLevel ?? LogLevel.Debug;
            logger.log(level, 'Recording Session Stopping');
        },
    };
    return reporter;
}
//# sourceMappingURL=logReporter.js.map